import { useState } from 'react';
import { readabilityService } from '../../../../services/readability-service';

export const useTextTranslation = () => {
  const [inputText, setInputText] = useState('');
  const [translationResult, setTranslationResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleInputChange = (e) => {
    setTranslationResult(null);
    setError(null);
    setInputText(e.target.value);
  };

  const clearInput = () => {
    setInputText('');
    setTranslationResult(null);
    setError(null);
  };

  const translateText = async () => {
    if (!inputText.trim()) {
      setError('Please enter some text to translate');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      setTranslationResult(null);
      const response = await readabilityService.translateText({ text: inputText });
      setTranslationResult(response);
    } catch (err) {
      console.error('Translation error:', err);
      setError('Error translating text. Please use text lookup for details.');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setSnackbarMessage('Copied to clipboard');
    } catch (err) {
      console.error('Could not copy text: ', err);
      setSnackbarMessage('Failed to copy to clipboard');
    }
  };

  const clearSnackbarMessage = () => setSnackbarMessage('');

  return {
    // State
    inputText,
    translationResult,
    loading,
    error,
    snackbarMessage,
    
    // Actions
    handleInputChange,
    clearInput,
    translateText,
    copyToClipboard,
    clearSnackbarMessage,
    
    // Computed values
    canTranslate: !loading && inputText.trim(),
    hasResults: !!translationResult
  };
};